export const taxFilterState = (venueId) => ({
  venueId,
  page: 1,
  pageSize: 20,
});
